<template>
  <div class="faq-container">
    <section v-for="(section, index) in sections" :key="index">
      <h2 class="text-lg text-bold">{{ section.title }}</h2>
      <ul>
        <li v-for="(item, itemIndex) in section.items" :key="itemIndex">
          <h3>{{ item.question }}</h3>
          <p v-html="item.answer"></p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sections: [
        {
          title: "My Account",
          items: [
            {
              question: "How do I create an account?",
              answer: "Click the icon at the top right of the page. Click \"Sign Up\" if you have not previously signed up online. Enter the information requested, then click \"Sign Up\"."
            },
            {
              question: "How can I update my personal information? (such as Birthday/Address)",
              answer: "You may click the icon at the top right of the page and update your personal information accordingly."
            },
            {
              question: "Is my personal information safe?",
              answer: "Your privacy is of the highest importance to us and the info that you send us is kept strictly confidential. We promise never to release your details to any outside company for mailing or marketing purposes. Read about our privacy policy <a href='/privacyPolicy'>here</a>."
            }
          ]
        },
        {
          title: "My Order",
          items: [
            {
              question: "Can I pick up the items I purchase at HQ or other partnered beauty salons?",
              answer: "We are sorry that we only provide delivery service for all customer purchases for the orders received on the website."
            },
            {
              question: "What are my payment options?",
              answer: "We accept all major credit & debit cards and Online bank Transfer FPX (all major domestic online banking). Meanwhile, we also accept offline bank transfers where you can pay to our bank account. Our bank account details are as follows:<br><br>Cel-Elements Holdings (M) S/B<br>Public Bank<br>3239775600"
            },
            {
              question: "How does the Voucher Code work?",
              answer: "All Voucher Codes are limited, while supplies last and cannot be used once they expire. These Voucher Codes are not redeemable for cash and are limited to one promotion per order. In some cases, the Voucher Code can only be redeemed once per person and has unique terms and conditions to allow fair redemption and distribution of discount codes to our valued customers."
            }
          ]
        },
        {
          title: "My Delivery",
          items: [
            {
              question: "How much does delivery cost?",
              answer: "Kindly refer to the delivery charges <a href='/deliveryPrice'>here</a>."
            },
            {
              question: "I accidentally added the wrong address at checkout, and now my order has been delivered there.",
              answer: "We encourage you to verify all shipping information before completing your order as we are not responsible for any orders mailed to the wrong address."
            },
            {
              question: "How long does it take to receive my goods?",
              answer: "While we are trying our best to pack and ship out the parcels quickly, the delivery speed depends solely on the courier service. Should you not receive your items after 7 days (West Malaysia) or 14 days (East Malaysia), feel free to connect with our customer service for assistance."
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.faq-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
}

h2 {
  margin-top: 30px;
  margin-bottom: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 20px;
}

h3 {
  margin-bottom: 10px;
}

</style>